module.exports = __webpack_public_path__ + "static/windows-f4ec92143880fd4bcb4a1e46c273aade.svg";